import { render, staticRenderFns } from "./etranslate-component.vue?vue&type=template&id=60f067db&scoped=true&"
import script from "./etranslate-component.vue?vue&type=script&lang=ts&"
export * from "./etranslate-component.vue?vue&type=script&lang=ts&"
import style0 from "./etranslate-component.vue?vue&type=style&index=0&id=60f067db&scoped=true&lang=scss&"
import style1 from "./etranslate-component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f067db",
  null
  
)

export default component.exports